import { getRandomRecipe } from "../services/RecipeService";
import { Link, useLoaderData } from "react-router-dom";
import { useEffect, useState } from "react";

const NotFoundBase = ({ recipe }) => (
	<div>
		<h1>Uh oh,</h1>
		<h2>One of us had too much to drink!</h2>
		<p>
			We weren't able to find the page you were looking for, but may we recommend a recipe?&nbsp;
			<Link to={`/recipe/${recipe.name}`}>
				<em>{ recipe.title }</em>
			</Link>
		</p>
	</div>
)

const NotFound = () => {
	const recipe = useLoaderData()

	return <NotFoundBase recipe={recipe} />
}

const NotFoundLoaderless = () => {
	const [recipe, setRecipe] = useState({})
	useEffect(() => {
		notFoundLoader().then(res => {
			setRecipe(res)
		})
	}, [setRecipe]);

	return <NotFoundBase recipe={recipe} />
}

function notFoundLoader() {
	return getRandomRecipe()
}

export default NotFound
export { notFoundLoader, NotFoundLoaderless }
